// utils/pricingCalculator.js
export const calculateRoomPrice = (rate, adultsCount, childrenCount) => {
  let totalPrice = 0;
  
  // console.log('🧮 PRICING CALCULATION START:', {
  //   rateName: rate.name,
  //   rateId: rate.id,
  //   adultsCount,
  //   childrenCount,
  //   adultPricing: rate.adult_pricing,
  //   childPricing: rate.child_pricing
  // });
  
  // Calculate adult pricing
  if (rate.adult_pricing) {
    const adultPrice = rate.adult_pricing.find(ap => ap.adults_count === adultsCount);
    // console.log('👨‍👩‍👧‍👦 ADULT PRICING LOOKUP:', {
    //   adultsCount,
    //   foundPrice: adultPrice,
    //   allPrices: rate.adult_pricing
    // });
    
    if (adultPrice) {
      totalPrice += adultPrice.price;
      // console.log('✅ USING ADULT PRICE:', adultPrice.price);
    } else {
      // If no exact match, use the maximum available or base price
      const maxAdultPrice = rate.adult_pricing.reduce((max, ap) => 
        ap.adults_count > max.adults_count ? ap : max
      );
      totalPrice += maxAdultPrice.price;
      // console.log('⚠️ USING MAX ADULT PRICE (no exact match):', maxAdultPrice.price);
    }
  } else {
    // Fallback if no adult_pricing structure
    totalPrice += rate.base_price || rate.originalPrice;
    // console.log('🔄 USING BASE PRICE (no adult_pricing):', rate.base_price || rate.originalPrice);
  }
  
  // Calculate child pricing
  if (rate.child_pricing && childrenCount > 0) {
    const childPrice = rate.child_pricing.find(cp => cp.children_count === childrenCount);
    // console.log('👶 CHILD PRICING LOOKUP:', {
    //   childrenCount,
    //   foundPrice: childPrice,
    //   allPrices: rate.child_pricing
    // });
    
    if (childPrice) {
      totalPrice += childPrice.price;
      // console.log('✅ USING CHILD PRICE:', childPrice.price);
    } else {
      // Use the maximum children count pricing available
      const maxChildPrice = rate.child_pricing.reduce((max, cp) => 
        cp.children_count > max.children_count ? cp : max
      );
      totalPrice += maxChildPrice.price;
      // console.log('⚠️ USING MAX CHILD PRICE (no exact match):', maxChildPrice.price);
    }
  } else {
    // console.log('➖ NO CHILD PRICING OR ZERO CHILDREN');
  }
  
  // console.log('💰 FINAL CALCULATED PRICE:', totalPrice);
  return totalPrice;
};